import axios from 'axios';
import { awsUrl, url } from '../../axiosInstance';

export const OpenTextGet = () => {

    return axios.get(`${awsUrl}/v1/openText`, {
        headers: {
            'Authorization': `bearer ${localStorage.jwtToken}`,
        },
    })

}


export const OpenTextSet = (data) => {

    return axios.post(`${url}OpenText`,
        data, {
        headers: {
            'Authorization': `bearer ${localStorage.token}`,
            "Access-Control-Allow-Origin": "*"
        },
    })
}